import React, { useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import DictTagsService from '../../../services/dict/DictTagsService';
import DictTagsCategoryService from '../../../services/dict/DictTagsCategoryService';
import { withTranslation } from 'react-i18next';
import { NewDictTagsDto } from '../../../types/types';

type Props = {
    dictTags: any[];
    onAddTag: (newTag: NewDictTagsDto) => void;
    t: any;
};

const AddDictTags: React.FC<Props> = ({ dictTags, onAddTag, t }) => {
    const [dictTagsCategories, setDictTagsCategories] = useState<any[]>([]);

    useEffect(() => {
        DictTagsCategoryService.getDictTagsCategory()
            .then(response => {
                setDictTagsCategories(response.data);
            })
            .catch(error => {
                console.error('Error fetching dictTagsCategories:', error);
            });
    }, []);

    const postDictTag = (values: { newDictTagName: string; selectedCategory: string; newDictTagDescription: string }) => {
        const selectedCategory = dictTagsCategories.find(category => category.id === values.selectedCategory);

        const newDictTag: NewDictTagsDto = {
            id: crypto.randomUUID(),
            dict: "BASIC", // Assuming "BASIC" as the dict value
            category: selectedCategory,
            dict_id: crypto.randomUUID(),
            name: values.newDictTagName,
            description: values.newDictTagDescription
        };

        DictTagsService.postDictTag(newDictTag)
            .then(response => {
                onAddTag(newDictTag);
            })
            .catch(error => {
                console.error('Error adding tag:', error);
            });
    };

    return (
        <div>
            <Formik
                initialValues={{
                    newDictTagName: '',
                    newDictTagDescription: '',
                    selectedCategory: ''     // Added selectedCategory to initial values
                }}
                validationSchema={Yup.object({
                    newDictTagName: Yup.string()
                        .required(t("validation.this_field_is_required"))
                        .notOneOf(dictTags.map(item => item.name), t("validation.name_already_exists")),
                    selectedCategory: Yup.string()
                        .required(t("validation.this_field_is_required")), // Added validation for selectedCategory
                    newDictTagDescription: Yup.string().required(t("validation.this_field_is_required"))
                    })}
                onSubmit={(values, { setSubmitting }) => {
                    postDictTag(values);
                    setSubmitting(false);
                }}
            >
                {formik => (
                    <Form>
                        <div className="form-container">
                            <Field name="newDictTagName" type="text" className="form-field" placeholder={t("table.name")} />
                            <ErrorMessage name="newDictTagName" component="div" className="error" />

                            <Field name="newDictTagDescription" type="text" className="form-field" placeholder={t("table.description")} />
                            <ErrorMessage name="newDictTagDescription" component="div" className="error" />

                            <Field as="select" name="selectedCategory" className="form-field">
                                <option value="" label={t("table.select_category")} />
                                {dictTagsCategories.map(category => (
                                    <option key={category.id} value={category.id}>
                                        {category.name}
                                    </option>
                                ))}
                            </Field>
                            <ErrorMessage name="selectedCategory" component="div" className="error" />

                            <button type="submit" disabled={formik.isSubmitting}>
                                {t("buttons.add")}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default withTranslation("global")(AddDictTags);